module.exports = __webpack_public_path__ + "media/images/signup-hero-d828270de456b53ebd54dcb99e5c9c4b.jpeg";